import { BuildingOfficeOrderSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "744a5f89-c1d4-4d23-b8aa-043bd392ec28",
    label: "DG(BLDG)'s Office Order No. 03 of 2021-2022",
    date: "08/09/2021",
    subject: "SOP for Dilapidated Building",
  },
  {
    fileStoreId: "9af245fb-b8dc-4df0-9a98-68024195e643",
    label: "DG(BLDG)'s Office Order No. 02 of 2021-2022",
    date: "26/08/2021",
    subject: "Liaison officer of KMC with Kolkata Police",
  },
  {
    fileStoreId: "30e932ff-333f-42b2-8741-549b8fbc462f",
    label: "DG(BLDG)'s Office Order No. 01 of 2021-2022",
    date: "01/06/2021",
    subject: "Applicability of Rule 26(2a)",
  },
];

const Officer_Order = () => (
  <TableStructure
    title="Office Order / 2021"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Officer_Order;
